import React from 'react';
import SanspathLogo from './SanspathLogo';
import adminOperationsImage from '../../assets/images/admin-operations-login.png';

const AuthShell = ({
  children,
  title,
  subtitle,
  eyebrow = '',
  maxWidth = 'max-w-md'
}) => {
  const desktopMaxWidth = {
    'max-w-md': 'lg:max-w-md',
    'max-w-3xl': 'lg:max-w-3xl'
  }[maxWidth] || maxWidth;

  return (
    <div className="auth-page relative min-h-screen overflow-hidden bg-white text-slate-900 lg:bg-slate-50">
      <div className="absolute inset-0 hidden bg-[linear-gradient(135deg,#f7fdfd_0%,#ecfeff_42%,#ffffff_100%)] lg:block" />
      <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-cyan-700 via-teal-400 to-emerald-400" />

      <main className="relative min-h-screen w-full lg:mx-auto lg:grid lg:max-w-6xl lg:grid-cols-[0.95fr_1.05fr] lg:items-center lg:gap-0 lg:px-8 lg:py-10">
        <aside className="pointer-events-none relative z-0 hidden h-[calc(100vh-5rem)] min-h-[620px] max-h-[760px] lg:block">
          <div className="relative h-full w-[calc(100%+12rem)] overflow-hidden rounded-lg border border-slate-200 bg-slate-200 shadow-[0_16px_40px_rgba(15,23,42,0.08)] xl:w-[calc(100%+14rem)]">
            <img
              src={adminOperationsImage}
              alt=""
              aria-hidden="true"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/60 via-slate-950/10 to-white/10" />
          </div>
        </aside>

        <section className={`relative z-10 min-h-screen w-full bg-white lg:mx-auto lg:min-h-0 lg:bg-transparent ${desktopMaxWidth}`}>
          <div className="flex min-h-screen w-full flex-col justify-center bg-white px-5 py-6 sm:px-8 lg:block lg:min-h-0 lg:rounded-lg lg:border lg:border-slate-200 lg:bg-white/95 lg:p-8 lg:shadow-[0_16px_40px_rgba(15,23,42,0.08)] lg:backdrop-blur">
            <div className="mb-8">
              <SanspathLogo className="mb-6 lg:hidden" imageClassName="h-12" />
              <SanspathLogo variant="mark" className="mb-5 hidden lg:flex" />
              <p className="mb-2 text-sm font-medium text-cyan-700">{eyebrow}</p>
              <h2 className="auth-heading text-2xl font-normal text-slate-950">{title}</h2>
              {subtitle && <p className="mt-2 text-sm leading-6 text-slate-600">{subtitle}</p>}
            </div>
            {children}
          </div>
        </section>
      </main>
    </div>
  );
};

export default AuthShell;
